
import { Component, Vue, Watch } from 'vue-property-decorator';
import BasePagina from '@/components/base/BasePagina.vue';
import BaseDialog from '@/components/base/BaseDialog.vue';
import BasePesquisa from '@/components/base/BasePesquisa.vue';
import BaseLista from '@/components/base/BaseLista.vue';
import BaseCampos from '@/components/base/BaseCampos.vue';
import DatePicker from '@/components/base/DatePicker.vue';
// Services
import UsuarioInternoService from '@/services/usuario-interno.service';
// Models
import { UsuarioFilter } from '@/shared/models/usuario/usuario.filter';
import { UsuarioInterface } from '@/shared/models/usuario/usuario.interface';
import { GeneroInterface } from '@/shared/models/usuario/genero.interface';
import { BaseDialogInterface } from '@/shared/models/base/dialog.interface';
// Utils
import Rules from '@/shared/utils/rules.util';
import Mask from '@/shared/utils/masks.util';
import Format from '@/shared/utils/format.util';

@Component({
  components: {
    BasePagina,
    BaseDialog,
    BasePesquisa,
    BaseLista,
    BaseCampos,
    DatePicker,
  },
})
export default class UsuarioAdministrativo extends Vue {
  private rules = Rules;

  private mask = Mask;

  public labelBotaoNovo = 'Novo Administrador';

  public editedItem = {} as UsuarioInterface;

  public editedGenero = {} as GeneroInterface;

  public dataNascimento: Record<string, any> = { date: '', time: '' };

  public filtro = {} as UsuarioFilter;

  public readonlyCpfDialog = false;

  // Dialog
  public dialogInterface = {
    formTitle: '',
    dialog: false,
    textBotaoPrimario: 'Salvar',
    funcaoPrimaria() {
      //
    },
    fecharModal: this.fecharModalCriarEditarExcluir,
    colorBotaoPrimario: 'primary',
  } as BaseDialogInterface;

  // Campos do Dialog
  public readonlyCamposDialog = false;

  public lista: Array<UsuarioInterface> = [];

  public headers: Array<Record<string, any>> = [
    {
      text: 'Nome', align: 'center', sortable: true, value: 'nome',
    },
    {
      text: 'E-mail', align: 'center', sortable: true, value: 'email',
    },
    {
      text: 'Celular', align: 'center', sortable: true, value: 'celular',
    },
    {
      text: 'Ação', align: 'center', sortable: false, value: 'acao',
    },
  ];

  public colapses = [
    { titulo: 'Filtragem', nomeSlot: 'pesquisa' },
    { titulo: 'Lista de Administradores', nomeSlot: 'lista' },
  ];

  public listaCamposPesquisa = [
    {
      text: 'Nome', type: 'textField', value: 'nome', cols: '3',
    },
    {
      text: 'CPF', type: 'textField', value: 'cpf', cols: '3', counter: '14', maxlength: '14',
    },
    {
      text: 'Celular', type: 'textField', value: 'celular', cols: '3', counter: '15', maxlength: '15',
    },
    {
      text: 'Email', type: 'textField', value: 'email', cols: '3',
    },
  ];

  public listaValues = [
    { value: 'celular', function: this.formatarCelular },
  ];

  public listaCamposEditar = [
    {
      text: 'Celular', mask: this.mask.celular, type: 'textField', value: 'celular', cols: '6', counter: '15', maxlength: '15', required: true, rules: [this.rules.campo_obrigatorio, this.rules.valida_somente_espacos],
    },
    {
      text: 'Nome', type: 'textField', value: 'nome', cols: '12', counter: '255', maxlength: '255', required: true, rules: [this.rules.campo_obrigatorio, this.rules.valida_somente_espacos],
    },
    {
      text: 'Email', type: 'textField', value: 'email', cols: '12', counter: '255', maxlength: '255', required: true, rules: [this.rules.campo_obrigatorio, this.rules.email],
    },
  ];

  public listaAcoes = [
    { tooltip: 'Editar', icon: 'mdi-square-edit-outline', function: this.abrirEditar },
    { tooltip: 'Excluir', icon: 'mdi-delete-outline', function: this.abrirExcluir },
  ];

  // Pesquisa
  async pesquisar(filtro: UsuarioFilter) {
    this.lista = await new UsuarioInternoService().buscarPorFiltro(filtro, true);
  }

  async buscarTodos() {
    this.lista = await new UsuarioInternoService().buscarPorFiltro({} as UsuarioFilter, false);
  }

  // Dialog de Editar
  private async abrirEditar(item: any) {
    this.dialogInterface.formTitle = 'Editar Administrador';
    this.dialogInterface.textBotaoPrimario = 'Salvar';
    this.dialogInterface.colorBotaoPrimario = 'primary';
    this.readonlyCamposDialog = false;
    this.readonlyCpfDialog = true;
    this.dialogInterface.funcaoPrimaria = this.salvarAtualizar;
    this.editedItem = await new UsuarioInternoService().buscarPorCPF(item.cpf);
    this.editedGenero = this.editedItem.genero;
    this.editedItem.cpf = Format.cpf(this.editedItem.cpf);
    this.editedItem.celular = Format.celular(this.editedItem.celular);
    if (this.editedItem !== undefined) {
      this.dataNascimento = this.formataDataParaVisualizar(this.editedItem.dataNascimento);
      this.dialogInterface.dialog = true;
    }
  }

  // Dialog de Criar
  private abrirCriar() {
    this.dialogInterface.formTitle = 'Novo Administrador';
    this.dialogInterface.textBotaoPrimario = 'Salvar';
    this.readonlyCamposDialog = false;
    this.readonlyCpfDialog = false;
    this.dialogInterface.colorBotaoPrimario = 'primary';
    this.dialogInterface.funcaoPrimaria = this.salvarAtualizar;
    this.editedItem = {} as UsuarioInterface;
    this.dialogInterface.dialog = true;
  }

  // Dialog de Excluir
  private async abrirExcluir(item: any) {
    this.dialogInterface.formTitle = 'Excluir Administrador';
    this.dialogInterface.textBotaoPrimario = 'Excluir';
    this.readonlyCamposDialog = true;
    this.readonlyCpfDialog = true;
    this.dialogInterface.colorBotaoPrimario = 'warning';
    this.dialogInterface.funcaoPrimaria = this.excluir;
    this.editedItem = await new UsuarioInternoService().buscarPorCPF(item.cpf);
    this.editedItem = await new UsuarioInternoService().buscarPorCPF(item.cpf);
    this.editedGenero = this.editedItem.genero;
    this.editedItem.cpf = Format.cpf(this.editedItem.cpf);
    this.editedItem.celular = Format.celular(this.editedItem.celular);
    if (this.editedItem !== undefined) {
      this.dataNascimento = this.formataDataParaVisualizar(this.editedItem.dataNascimento);
      this.dialogInterface.dialog = true;
    }
  }

  async salvarAtualizar() {
    this.editedItem.dataNascimento = this.formataDataParaSalvar(this.dataNascimento);
    this.editedItem.genero = this.getGeneroSelecionado(this.editedGenero.id);
    new UsuarioInternoService().salvarAtualizar(this.editedItem)
      .then(() => {
        this.fecharModalCriarEditarExcluir();
        this.pesquisar(this.filtro);
      });
  }

  async excluir() {
    new UsuarioInternoService().excluir(this.editedItem)
      .then(() => {
        this.fecharModalCriarEditarExcluir();
        this.pesquisar(this.filtro);
      });
  }

  private fecharModalCriarEditarExcluir() {
    this.dialogInterface.dialog = false;
    this.editedItem = {} as UsuarioInterface;
  }

  private formatarCelular(usuario: UsuarioInterface) {
    return Format.celular(usuario.celular);
  }

  private getAllGeneros() {
    return [
      { id: 'M', descricao: 'Masculino' },
      { id: 'F', descricao: 'Feminino' },
      { id: 'P', descricao: 'Personalizado' },
    ];
  }

  private formataDataParaVisualizar(dateTime: string) {
    const [day, month, year] = dateTime.substring(0, 10).split('-');
    return { date: `${day}-${month}-${year}` };
  }

  private formataDataParaSalvar(dateTime: Record<string, any>) {
    const [year, month, day] = (dateTime as any).date.split('-');
    return `${year}-${month}-${day}`;
  }

  getGeneroSelecionado(genero: string) {
    return this.getAllGeneros().filter((g) => g.id === genero)[0];
  }

  mounted() {
    this.buscarTodos();
  }
}
